import "./History.scss";
import { API_BASE_URL } from "configs/AppConfig";
import LabelLang from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import { useEffect } from "react";

function History() {

  const dir = useSelector(({theme})=>theme.direction);

  const flag = process.env.PUBLIC_URL + "/image/tt3.svg";

        
  ReactGA.initialize(END_POINTS.TRACKING_ID);
  
  useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/about/device-history", title: "About History Page" });
  }, []);
  
  
  const history = [
    {
      img: '',
      title: 'إنشاء أول مكتب للإحصاء في مصر',
      year: 1870,
      details: `كان ذلك في عهد الخديوي إسماعيل، وكانت مهمة المكتب جمع البيانات
                عن الخدمات المختلفة التي تقوم بها الدولة وإصدار المجلد الإحصائي
                "إحصاءات مصر".`
    },
    {
      img: process.env.PUBLIC_URL + "/image/tt.png",
      title: 'إنشاء مكتب عموم الإحصاء',
      year: 1907,
      details: `وكان يتبع مصلحة المساحة المصرية. وفي عام 1911 تم تطوير مكتب عموم الإحصاء وأصبح له استقلالية وأطلق عليه اسم مصلحة عموم الإحصاء، كما تم ضم المكتب الإحصائي التابع لمصلحة الخدمات الصحية إلى المصلحة في 1915`
    },
    {
      img: process.env.PUBLIC_URL + "/image/t2.png",
      title: 'أول سلسلة أرقام قياسية لأسعار المستهلكين',
      year: 1914,
      details: `وذلك باتخاذ السنة المالية 1913/1914 كسنة أساس عن مدينة القاهرة فقط`
    },
    {
      img: process.env.PUBLIC_URL + "/image/tt4.png",
      title: 'أول إحصاء صناعي متخصص',
      year: 1937,
      details: `وبدأ إجراء هذا الإحصاء كل ثلاث سنوات باتباع أسلوب الحصر الشامل في الأعوام 1944 و1947 و1950`
    },
    {
      img: process.env.PUBLIC_URL + "/image/t5.png",
      title: 'أول سلسلة أرقام قياسية لأسعار المستهلكين',
      year: 1991,
      details: `وذلك باتخاذ السنة المالية 1913/1914 كسنة أساس عن مدينة القاهرة فقط`
    },
    {
      img: process.env.PUBLIC_URL + "/image/v7.png",
      title: 'إنشاء الجهاز المركزي للتعبئة العامة والإحصاء',
      year: 1937,
      details: `وذلك بقرار رئيس الجمهورية بالقانون رقم 2915 بإنشاء والتنظيم الجهاز على أن يكون هيئة مستقلة تابعة لرئاسة الجمهورية`
    },
    {
      img: process.env.PUBLIC_URL + "/image/v6.png",
      title: 'أول سلسلة أرقام قياسية لأسعار المستهلكين',
      year: 1914,
      details: `وذلك باتخاذ السنة المالية 1913/1914 كسنة أساس عن مدينة القاهرة فقط`
    },
  ]
  
  const historyList = useSWR({
    url: END_POINTS.HISTORY
  });

  
  return (
    <ContentLoading isLoading={historyList.isLoading}>
      {historyList?.data?.data ? (
        <div className="row time-line">
          <div className="col-12 col-md-6">
            {historyList?.data?.data && historyList?.data?.data
              .filter((el, i) => i % 2 === 0)
              .map(({ imageUrl, title, year, description, capmasHistoryTranslations }, i) => (
                <div key={i} className="item-h start-r">
                  {i === 0 ? (
                    <div className="h-head"></div>
                  ) : (
                    <div className="h-head">
                      <img
                        src={
                          imageUrl !== null && imageUrl !== undefined
                            ? `${API_BASE_URL}/${imageUrl}`
                            : history[1].img
                        }
                        alt="historyImage"
                        style={{ width: "180px", height: "150px" }}
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className="h-body">
                    <p className={dir === 'ltr' && 'after-rotate'}>
                        <LabelLang
                          id={'title'}
                          defaultValue={title}
                          translations={capmasHistoryTranslations}
                        />
                    </p>
                    <span>{year}</span>
                    <img src={flag} alt="flag" loading="lazy" />
                  </div>
                  <div className="h-foot" style={{ textAlign: "justify" }}>
                    <p>
                      <LabelLang
                        id={'description'}
                        defaultValue={description}
                        translations={capmasHistoryTranslations}
                      />
                    </p>
                  </div>
                </div>
              ))}
          </div>

          <div className="col-12 col-md-6">
            {historyList?.data?.data && historyList?.data?.data
              .filter((el, i) => i % 2 === 1)
              .map(({ imageUrl, title, year, description, capmasHistoryTranslations }, i) => (
                <div key={i} className="item-h start-l">
                  <div className="h-head">
                    <img
                      src={
                        imageUrl !== null && imageUrl !== undefined
                          ? `${API_BASE_URL}/${imageUrl}`
                          : history[2].img
                      }
                      alt="historyImage"
                      style={{ width: "180px", height: "150px" }}
                      loading="lazy"
                    />
                  </div>
                  <div className="h-body">
                    <img src={flag} alt="flag" loading="lazy" />
                    <span>{year}</span>
                    <p className={dir === 'ltr' && 'after-rotate'}>
                      <LabelLang
                        id={'title'}
                        defaultValue={title}
                        translations={capmasHistoryTranslations}
                      />
                    </p>
                  </div>
                  <div className="h-foot" style={{ textAlign: "justify" }}>
                    <p>
                      <LabelLang
                        id={'description'}
                        defaultValue={description}
                        translations={capmasHistoryTranslations}
                      />
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )
      :
      <DataNotFound />}
    </ContentLoading>
  );
}

export default History;
